export default __webpack_public_path__ + "static/media/homePage_background.dfa0e8cc.png";